import React from "react";

import { INotification } from "@telnyx/webrtc/lib/src/index";

export const TelnyxCallContext = React.createContext({
  notification: undefined as INotification | undefined,
  isClientReady: false,
  logs: [] as string[]
});
